import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import { task } from 'ember-concurrency';
import TransactionalMessageModel from 'cio/models/transactional-message';

export default class TransactionalMessageOverviewController extends Controller {
  @service router!: RouterService;

  declare model: TransactionalMessageModel;

  tabs = [
    {
      path: 'transactional.message.overview.index',
      title: 'Overview',
    },
    {
      path: 'transactional.message.overview.metrics',
      title: 'Metrics',
    },
    {
      path: 'transactional.message.overview.sent',
      title: 'Sent',
    },
    {
      path: 'transactional.message.overview.drafts',
      title: 'Drafts',
    },
  ];

  @action
  onDeleteMessage() {
    this.router.transitionTo('transactional');
  }

  onStopMessage = task(async () => {
    this.router.transitionTo('transactional.message');
    this.reloadMessageModel();
  });

  @action
  async reloadMessageModel() {
    await this.model.reload(); // reload route model to update pagination counts
  }
}

declare module '@ember/controller' {
  interface Registry {
    'transactional.message.overview': TransactionalMessageOverviewController;
  }
}
